"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migratedInsightTypes = exports.continuousMigrationInsightTypes = exports.AllPreferencesFeatureFlag = exports.OtherPreferencesFeatureFlag = exports.ruleIDToMoTFeatureFlagMapping = exports.MoTFeatureFlag = exports.UnleashFeatureFlagKeys = void 0;
const insights_engine_models_1 = require("@forto-dev/insights-engine-models");
var UnleashFeatureFlagKeys;
(function (UnleashFeatureFlagKeys) {
    UnleashFeatureFlagKeys["CRD_MOT"] = "crdMoT";
    UnleashFeatureFlagKeys["CARGO_ROLLOVER_MOT"] = "cargoRolloverMoT";
    UnleashFeatureFlagKeys["MAIN_CARRIAGE_DELAY_MOT"] = "mainCarriageDelayMoT";
    UnleashFeatureFlagKeys["CUSTOMS_MOT"] = "customsMoT";
    UnleashFeatureFlagKeys["DEM_DET_MOT"] = "mot.dem_det";
    UnleashFeatureFlagKeys["CUSTOMS_EXCEPTION_MOT"] = "customsExceptionMoT";
    UnleashFeatureFlagKeys["BOOKING_MOT"] = "bookingMoT";
    UnleashFeatureFlagKeys["OTHER_NOTIFICATION_PREFERENCES_MIGRATION"] = "otherNotificationPreferencesMigration";
    UnleashFeatureFlagKeys["GLOBAL_MOT_UI"] = "globalMotUI";
    UnleashFeatureFlagKeys["GLOBAL_MOT_RULES"] = "globalMotRules";
    UnleashFeatureFlagKeys["DEM_DET_VISIBILITY"] = "insights-integrations.releases.dem_det-approval-notify-ops-empty-subscribers";
    UnleashFeatureFlagKeys["DEM_DET_COMBINED_STORAGE"] = "insights-integrations.releases.demDetStorageCharges";
})(UnleashFeatureFlagKeys || (exports.UnleashFeatureFlagKeys = UnleashFeatureFlagKeys = {}));
exports.MoTFeatureFlag = {
    CRDMoT: UnleashFeatureFlagKeys.CRD_MOT,
    CargoRolloverMoT: UnleashFeatureFlagKeys.CARGO_ROLLOVER_MOT,
    MainCarriageDelayMoT: UnleashFeatureFlagKeys.MAIN_CARRIAGE_DELAY_MOT,
    CustomsMoT: UnleashFeatureFlagKeys.CUSTOMS_MOT,
    DemDetMot: UnleashFeatureFlagKeys.DEM_DET_MOT,
    CustomsExceptionMoT: UnleashFeatureFlagKeys.CUSTOMS_EXCEPTION_MOT,
    BookingMoT: UnleashFeatureFlagKeys.BOOKING_MOT,
};
exports.ruleIDToMoTFeatureFlagMapping = {
    [insights_engine_models_1.RuleID.MoT04_EV03_CRD_LastMinute]: 'CRDMoT',
    [insights_engine_models_1.RuleID.MoT02_EV02_RolledCargo]: 'CargoRolloverMoT',
    [insights_engine_models_1.RuleID.MoT01_EV01_MainCarriagePOL]: 'MainCarriageDelayMoT',
    [insights_engine_models_1.RuleID.MoT02_EV02_Customs_DocumentInspection]: 'CustomsMoT',
    [insights_engine_models_1.RuleID.MoT04_EV01_CRD_Other]: 'CRDMoT',
    [insights_engine_models_1.RuleID.MoT04_EV02_CRD_Major]: 'CRDMoT',
    [insights_engine_models_1.RuleID.MoT04_EV04_CRD_NotInTime]: 'CRDMoT',
    [insights_engine_models_1.RuleID.MoT01_EV02_MainCarriagePOD]: 'MainCarriageDelayMoT',
    [insights_engine_models_1.RuleID.MoT01_EV03_MissedVesselTS]: 'MainCarriageDelayMoT',
    [insights_engine_models_1.RuleID.MoT01_EV04_MainCarriagePOLTS]: 'MainCarriageDelayMoT',
    [insights_engine_models_1.RuleID.MoT01_EV05_MainCarriagePODTS]: 'MainCarriageDelayMoT',
    [insights_engine_models_1.RuleID.MoT02_EV01_Customs_ClearedNoInspection]: 'CustomsMoT',
    [insights_engine_models_1.RuleID.MoT02_EV03_Customs_PhysicalInspection]: 'CustomsMoT',
    [insights_engine_models_1.RuleID.MoT02_EV04_Customs_ClearedAfterInspection]: 'CustomsMoT',
    [insights_engine_models_1.RuleID.MoT02_DEM01_DemFreeDaysUpdated]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DEM02_DemFreeDaysExceededInPort]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DEM03_DemFreeDaysExceededLeftPort]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DEM04_DemPlannedTransport]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DEM05_DemFreeDaysExceededLeftPort]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DEM05_DemPreFreeDaysExceededLeftPort]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DET03_DetFreeDaysExceededContainerReturned]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DET04_DetPlannedTransport]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DET05_DetFreeDaysExceededContainerReturned]: 'DemDetMot',
    [insights_engine_models_1.RuleID.MoT02_DET05_DetPreFreeDaysExceededContainerReturned]: 'DemDetMot',
};
exports.OtherPreferencesFeatureFlag = {
    NotificationSettings: UnleashFeatureFlagKeys.OTHER_NOTIFICATION_PREFERENCES_MIGRATION,
};
exports.AllPreferencesFeatureFlag = Object.assign(Object.assign({}, exports.MoTFeatureFlag), exports.OtherPreferencesFeatureFlag);
exports.continuousMigrationInsightTypes = [
    insights_engine_models_1.RuleID.Shipment_New_Message,
    insights_engine_models_1.RuleID.Shipment_Document_Upload,
    insights_engine_models_1.RuleID.Booking_New_Message,
    insights_engine_models_1.RuleID.Shipment_Internal_Note,
    insights_engine_models_1.RuleID.Booking_Internal_Note,
];
exports.migratedInsightTypes = [
    ...exports.continuousMigrationInsightTypes,
    insights_engine_models_1.RuleID.ShipmentArrivalUpdate,
    insights_engine_models_1.RuleID.ShipmentDepartureUpdate,
    insights_engine_models_1.RuleID.ShipmentCargoReadyUpdate,
    insights_engine_models_1.RuleID.ShipmentDeliveryUpdate,
    insights_engine_models_1.RuleID.ShipmentPickupUpdate,
];
//# sourceMappingURL=unleashFeatureFlags.js.map